import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent } from './core/components/footer/footer.component';
import { TitleComponent } from "./core/components/title/title.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, TitleComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Hakikat | Admin Panel';
}
